// confirmDeploymentSites.tsx
//
// (c) NCR Voyix Corporation 2025. All rights reserved.

import React from 'react'
import { connect } from 'react-redux'
import ContinueDialogBox from '../../../components/ContinueDialogBox'
import SelectedSitesTable from './selectedSitesTable'

export interface OwnProps {
  open: boolean
  isSaving: boolean
  onCancel: () => void
  onContinue: () => void
}

type DeploymentSitesTableProps = OwnProps

export function ConfirmDeploymentSitesModal(
  {
    open,
    isSaving,
    onCancel,
    onContinue
  }: Readonly<DeploymentSitesTableProps>
): JSX.Element {
  return (
    <ContinueDialogBox
      open={open}
      loading={isSaving}
      title="Deployment Sites"
      description="You have chosen to update the Solution Set for the selected sites. NOTE: This will NOT upgrade the site(s). Do you wish to proceed?"
      cancelButtonText="Cancel"
      continueButtonText="Continue"
      onCancel={onCancel}
      onContinue={onContinue}
      content={(
        <SelectedSitesTable />
      )}
    />
  )
}

export default connect(null)(ConfirmDeploymentSitesModal)
